import React from 'react';
import firebase from '../firebaseConfig';
import {Loading , LoadingImage} from './wrapper/Loading';
import '../css/detailproduct.css';
import ReactMarkdown from "react-markdown";
import {Helmet} from "react-helmet";
import { Carousel, Container, Image, Row, Col,Form, Button, Navbar } from 'react-bootstrap';
import ReactPixel from 'react-facebook-pixel';


class DetailProduct  extends React.Component{
    constructor(){
        super();
        this.state={
            loading:true,
            product:[],
            varian:"", 
            ukuran:0, 
            jumlah:1, 
            imageLoading:true
        }

        ReactPixel.init('821601849045779');
    }

    componentDidMount() {
        this.timerID = setInterval(
          () => this.getData(),
          1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    getData(){
     const db = firebase.firestore();
       db.collection('products').doc(this.props.match.params.id).get().then(doc => {
           if(doc){
                this.setState({loading:false,product:doc.data()});
           }
           
        })
    }

    handleImageLoaded() {
        this.setState({ imageLoading: false });
      }
    
      handleImageErrored() {
        this.setState({ imageLoading: true });
      }

    onSubmit = () =>{
        ReactPixel.track('chat', 'WA');

        if(this.state.ukuran!==0 && this.state.varian!=="" && this.state.jumlah>1){
            window.location.assign('https://api.whatsapp.com/send?phone=6281265237536&text=Halo Admin ORUSS, saya ingin memesan '+this.state.jumlah+' buah '+this.state.product.namaProduct+' dengan varian '+this.state.varian+' ukuran '+this.state.ukuran);
        }

        else if(this.state.ukuran!==0 && this.state.varian!==""){
            window.location.assign('https://api.whatsapp.com/send?phone=6281265237536&text=Halo Admin ORUSS, saya ingin memesan '+this.state.product.namaProduct+' dengan varian '+this.state.varian+' ukuran '+this.state.ukuran);
        }

        else if(this.state.jumlah>1 && this.state.ukuran!==0){
            window.location.assign('https://api.whatsapp.com/send?phone=6281265237536&text=Halo Admin ORUSS, saya ingin memesan '+this.state.jumlah+' buah '+this.state.product.namaProduct+' dengan ukuran '+this.state.ukuran);
        }

        else if(this.state.jumlah>1 && this.state.varian!==""){
            window.location.assign('https://api.whatsapp.com/send?phone=6281265237536&text=Halo Admin ORUSS, saya ingin memesan '+this.state.jumlah+' buah '+this.state.product.namaProduct+' dengan varian '+this.state.varian);
        }

        else if(this.state.jumlah>1){
            window.location.assign('https://api.whatsapp.com/send?phone=6281265237536&text=Halo Admin ORUSS, saya ingin memesan '+this.state.jumlah+' buah '+this.state.product.namaProduct);
        }
        
        else if(this.state.varian!==""){
            window.location.assign('https://api.whatsapp.com/send?phone=6281265237536&text=Halo Admin ORUSS, saya ingin memesan '+this.state.product.namaProduct+' dengan varian '+this.state.varian);
        }
        
        else if(this.state.ukuran!==0){
            window.location.assign('https://api.whatsapp.com/send?phone=6281265237536&text=Halo Admin ORUSS, saya ingin memesan '+this.state.product.namaProduct+' dengan ukuran '+this.state.ukuran);
        }

        else{
            window.location.assign('https://api.whatsapp.com/send?phone=6281265237536&text=Halo Admin ORUSS, saya ingin memesan '+this.state.product.namaProduct);
        }
    }

    render(){
        
        ReactPixel.pageView();
        if(this.state.loading){
            return(
                 <Loading/>
            );
        }
        const input=this.state.product.deskripsiProduct;
        
        return( 
            <div>
                 <Helmet>
                    <title> {this.state.product.namaProduct} | ORUSS Official</title>
                </Helmet>
                <Container>
                    <Row>
                        <Col md={6}>
                           {this.state.imageLoading===true && (
                               <LoadingImage/>
                           )}
                            <Carousel>
                                {this.state.product.gambarProduct.map((link)=>(
                                    <Carousel.Item key={link}>
                                        <Image src={link} alt="gambar" 
                                            className="d-block w-100"
                                            onLoad={this.handleImageLoaded.bind(this)}
                                            onError={this.handleImageErrored.bind(this)}
                                        />
                                    </Carousel.Item>
                                ))}
                                
                            </Carousel>
                            <small class="font-italic">*Geser untuk melihat gambar lainnya</small>
                        </Col>
                        <Col md={6} className="p-4">
                            <h3 className="mb-3"><strong>{this.state.product.namaProduct}</strong></h3>
                            <h5><strike><strong>Rp {this.state.product.hargaProduct + 100000}</strong></strike></h5>
                            <h4 className="mb-0"><strong>Rp {this.state.product.hargaProduct}</strong> </h4>
                            <small><i>*harga belum termasuk ongkir</i></small>


                            <Form className="mt-4">

                                <Form.Group controlId="exampleForm.SelectCustom" className="mb-4" >
                                    <Form.Label><strong>Motif</strong></Form.Label>
                                    <Form.Control as="select" custom defaultValue={this.state.varian} onChange={e => this.setState({ varian:e.target.value })}>
                                        <option value="">Silakan Pilih</option>
                                        {this.state.product.varianProduct.map((varian)=>(
                                            <option key={varian} value={varian}>{varian}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>

                                {/* <Form.Group controlId="exampleForm.SelectCustom" className="mb-4" >
                                    <Form.Label><strong>Ukuran</strong></Form.Label>
                                    <Form.Control as="select" custom defaultValue={this.state.ukuran} onChange={e => this.setState({ ukuran:e.target.value })}>
                                        <option value="">Silakan Pilih</option>
                                        {this.state.product.ukuranProduct.map((ukuran)=>(
                                            <option key={ukuran} value={ukuran}>{ukuran}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group> */}
                                

                            


                            <Row className="mt-5">
                                <Col xs={3}>
                                    <Form.Group controlId="formBasicEmail">
                                        <Form.Control type="number" size="lg"  min="1"  defaultValue={this.state.jumlah} onChange={e => this.setState({ jumlah:e.target.value })}/>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Button variant="dark" size="lg" onClick={this.onSubmit}>BELI SEKARANG</Button>{' '}
                                </Col>
                            </Row>
                            </Form>

                        </Col>
                    </Row>
                </Container>

                <hr/>
                <Container>
                    <Row>
                        <Col>
                        <ReactMarkdown source={input.replace(/\\n/g, '  \n')}/>
                        </Col>
                        
                    </Row>
                </Container>

                <Navbar variant="dark"  fixed="bottom">
                <Container>
                    <Button variant="warning" size="lg" className="mx-auto" onClick={this.onSubmit} block>
                        <h5 className="mb-0"> <strong><i class="far fa-hand-point-up"></i> BELI SEKARANG</strong>  </h5> 
                        <strong className="harga">
                            <strike><small>Rp {this.state.product.hargaProduct + 100000}</small></strike> - Rp {this.state.product.hargaProduct}
                        </strong>
                        <br/>
                        <small className="text-light">
                            *hanya untuk hari ini
                        </small>
                    </Button>
               
                </Container>
            </Navbar>
            </div>
        );
    }

    }



export default DetailProduct;